import { theme } from 'antd';
import { useTranslation } from 'react-i18next';

import DigitalCounter from '@/components/DigitalCounter.tsx';
import { Authentication } from '@/rbac';
import { useOperatorStore } from '@/routes/arc/stores/operator.store.ts';

export const Route = createFileRoute({
  component: AvailablePage,
});

function AvailablePage() {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const waitNumber = useOperatorStore((s) => s.waitNumber);
  const operatorStore = useOperatorStore();

  if (operatorStore.status !== 'AVAILABLE') {
    return null;
  }

  return (
    <Authentication failMode={'empty'} require={'arc:call:answer'}>
      <div
        className={'fcc fdc h-[80vh] text-[50px]'}
        style={{ color: token.colorPrimary }}
      >
        <div className={'text-[20px]'}>
          {t('arc.widgets.available.AvailablePage.operatorsAhead')}
        </div>
        <div className={'fcc mt-20'}>
          <DigitalCounter className={'text-[100px]'} value={waitNumber ?? 0} />
        </div>
      </div>
    </Authentication>
  );
}
